import { defineStore } from 'pinia';

export const usePerfilOficialSectionsStore = defineStore(
  'ap.perfilOficialSections',
  () => {
    const sectionData = ref<HomeSectionData | null>(null);
    const loading = ref(false);
    const error = ref<string | null>(null);
    const currentSlug = ref<string | null>(null);

    function setSectionData(data: HomeSectionData | null) {
      sectionData.value = data;
    }

    // Items ordenados por priority
    const sortedItems = computed(() => {
      if (!sectionData.value) return [];

      return [...sectionData.value.items].sort(
        (a, b) => a.priority - b.priority,
      );
    });

    // Type guard helper
    function isHomeTabsData(
      data: HomeCategoryData | HomeTabsData,
    ): data is HomeTabsData {
      return 'categories' in data;
    }

    // Items válidos (com jogos ou placeholders)
    const validItems = computed(() => {
      return sortedItems.value.filter((item) => {
        if (item.content_type === 'PLACEHOLDER') return true;

        if (item.content_type === 'TABS') {
          if (item.type === 'section' && isHomeTabsData(item.data)) {
            return item.data.categories && item.data.categories.length > 0;
          }

          if (item.type === 'category' && 'games' in item.data) {
            return item.data.games && item.data.games.length > 0;
          }

          return false;
        }

        if ('games' in item.data) {
          return item.data.games && item.data.games.length > 0;
        }

        return false;
      });
    });

    const hasItems = computed(() => validItems.value.length > 0);

    function reset() {
      sectionData.value = null;
      loading.value = false;
      error.value = null;
      currentSlug.value = null;
    }

    return {
      sectionData,
      setSectionData,
      sortedItems,
      validItems,
      hasItems,
      loading,
      error,
      currentSlug,
      reset,
    };
  },
);
